import Swiper from "swiper/bundle";

/**
 * css ブレイクポイントの値を取得
 */
const root = document.querySelector(":root");
const breakmaxtab = window.getComputedStyle(root).getPropertyValue("--break-maxtab");
const breakPc = window.getComputedStyle(root).getPropertyValue("--break-pc");
const breakTab = window.getComputedStyle(root).getPropertyValue("--break-tab");

const swipers = document.querySelectorAll(".swiper");

/* 指定したswiperIDのスライドをランダムにする関数 */
function shuffleSlide(swiperID) {
  const slidesContainer = document.getElementById(swiperID).querySelector(".swiper-wrapper");
  // スライド要素を配列に変換
  const slides = Array.from(slidesContainer.children);

  // スライド要素をランダムに並び替える関数
  function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      let j = Math.floor(Math.random() * (i + 1));
      let temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
  }

  // スライド要素をランダムに並び替える
  shuffleArray(slides);

  // シャッフルしたスライド要素を親要素に追加
  slides.forEach(function (slide) {
    slidesContainer.appendChild(slide);
  });
}

/**
 * 初期化 (トップ)
 */

const body = document.querySelector("body");

if (body.classList.contains("home")) {
  shuffleSlide("swiperTopMv");

  const swiperTopMv = new Swiper("#swiperTopMv", {
    loop: true,
    effect: "fade",
    autoplay: {
      delay: 7000,
      disableOnInteraction: false,
    },
    speed: 2000,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  const swiperTopBanner = new Swiper("#swiperTopBanner", {
    centeredSlides: false,

    loop: true,
    // rewind: true,
    slidesPerView: 1.3,
    spaceBetween: 24,
    grabCursor: true,
    centeredSlides: true,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    speed: 500,
    navigation: false,

    breakpoints: {
      [breakTab]: {
        slidesPerView: 2,
        centeredSlides: false,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
        },
      },
      [breakPc]: {
        slidesPerView: 4,
        centeredSlides: false,
      },
    },

    // pagination: {
    //   el: ".swiper-pagination",
    //   type: 'bullets',
    //   clickable: true,
    // },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  const swiperTopEvent = new Swiper("#swiperTopEvent", {
    centeredSlides: false,

    loop: false,
    // rewind: true,
    slidesPerView: 1.2,
    spaceBetween: 24,
    grabCursor: true,
    // autoplay: {
    //   delay: 6000,
    //   disableOnInteraction: false,
    // },
    speed: 500,

    breakpoints: {
      [breakTab]: {
        slidesPerView: 2.3,
      },
      [breakPc]: {
        slidesPerView: 2.6,
      },
    },

    // pagination: {
    //   el: ".swiper-pagination",
    //   type: 'bullets',
    //   clickable: true,
    // },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

	const recommendSection = document.getElementById("swiperTopRecommend");
	if(recommendSection) {
		shuffleSlide("swiperTopRecommend");
	}

  const swiperTopRecommend = new Swiper("#swiperTopRecommend", {
    centeredSlides: false,

		loop: true,
    // rewind: true,
    slidesPerView: 2,
    spaceBetween: 24,
    grabCursor: true,
    centeredSlides: true,
    // autoplay: {
    //   delay: 6000,
    //   disableOnInteraction: false,
    // },
    speed: 500,

    breakpoints: {
      [breakTab]: {
        slidesPerView: 3.6,
      },
      [breakPc]: {
        slidesPerView: 6,
      },
    },

    // pagination: {
    //   el: ".swiper-pagination",
    //   type: 'bullets',
    //   clickable: true,
    // },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}

/***************************************** */

/**
 * 初期化 (下層)
 */

const swiperLibe = new Swiper("#swiperLibe", {
  centeredSlides: false,

  loop: false,
  slidesPerView: 2.5,
  spaceBetween: 24,
  grabCursor: true,
  speed: 500,

  breakpoints: {
    [breakTab]: {
      slidesPerView: 4.5,
    },
    [breakPc]: {
      slidesPerView: 5.5,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

const swiperLibeHirakata = new Swiper("#swiperLibeHirakata", {
  centeredSlides: false,

  loop: false,
  slidesPerView: 2.5,
  spaceBetween: 24,
  grabCursor: true,
  speed: 500,

  breakpoints: {
    [breakTab]: {
      slidesPerView: 4.5,
    },
    [breakPc]: {
      slidesPerView: 5.5,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

const swiperRareBooks = new Swiper("#swiperRareBooks", {
  loop: false,
  slidesPerView: 1,
  grabCursor: true,
  centeredSlides: true,
  speed: 500,

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

const galleryThumbs = new Swiper(".gallery-thumbs", {
  centeredSlides: false,
  centeredSlidesBounds: true,
  slidesPerView: 4,
  watchOverflow: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  direction: "horizontal",
  breakpoints: {
    [breakPc]: {
      centeredSlides: true,
      slidesPerView: 3,
      direction: "vertical",
    },
  },
});

const galleryMain = new Swiper(".gallery-main", {
  watchOverflow: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  preventInteractionOnTransition: true,
  preloadImages: false,
  lazy: true,
  lazy: {
    loadPrevNext: true,
    loadOnTransitionStart: true,
  },
  zoom: {
    maxRatio: 3,
    zoomedSlide: {
      toggle: false,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  thumbs: {
    swiper: galleryThumbs,
  },
});

/* サムネイルクリック時のずれる動き */
galleryMain.on("slideChangeTransitionStart", function () {
  galleryThumbs.slideTo(galleryMain.activeIndex);
});

/***************************************** */

/**
 * prev,nextのボタンを、サムネイルの高さの中央に配置
 */

swipers.forEach((swiper) => {
  const figure = swiper.querySelector("figure");
  const button = swiper.querySelector(".swiper-button-next");

  // figure要素とボタン要素が存在する場合のみ
  if (figure && button) {
    const figureHeight = figure.clientHeight;
    const buttonHeight = button.clientHeight;
    const buttonTop = figureHeight / 2 + buttonHeight / 2;
    const buttons = swiper.querySelectorAll('[class*="swiper-button-"]');
    buttons.forEach((button) => {
      button.style.top = `${buttonTop}px`;
    });
  }
});


console.log('chkeke')